import React, { useMemo } from 'react';
export function extractTagsFromDescription(description) {
    const raw = String(description || '');
    const tagRegex = /(^|\s)#([a-zA-Z0-9_-]+)/g;
    // Preserve original tag casing for display, but de-dupe case-insensitively.
    const tagMap = new Map();
    let match;
    while ((match = tagRegex.exec(raw)) !== null) {
        const tag = match[2];
        const key = tag.toLowerCase();
        if (!tagMap.has(key))
            tagMap.set(key, tag);
    }
    const tags = Array.from(tagMap.values());
    const text = raw
        .replace(/(^|\s)#[a-zA-Z0-9_-]+/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
    return { text, tags };
}
export const DescriptionWithTags = ({ description, emptyText = 'No description provided.', tagClassName }) => {
    const { text, tags } = useMemo(() => extractTagsFromDescription(description || ''), [description]);
    return (React.createElement(React.Fragment, null,
        text ? (React.createElement("p", { className: "text-sm text-gray-600 mb-3" }, text)) : (React.createElement("p", { className: "text-sm text-gray-500 mb-3 italic" }, emptyText)),
        tags.length > 0 && (React.createElement("div", { className: "flex flex-wrap gap-2" }, tags.map((tag) => (React.createElement("span", { key: tag, className: tagClassName ||
                'inline-block px-2.5 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-full' }, tag)))))));
};
export default DescriptionWithTags;
